var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"flex flex-no-shrink p-4 mb-1 px-8 cursor-pointer no-underline text-white hover:bg-gray-800",attrs:{"to":_vm.route}},[_c('div',{staticClass:"mr-4 w-4"},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }